// removed by extract-text-webpack-plugin
module.exports = {"warning-text-color":"#E28913","error-text-color":"#CA402B","label-width":"12rem","messages":"_3NTz-yRslCwhAYU_71mCwo","scrollable":"_2XOzOTXQCfEZfFOnDNhNa","noIndent":"UXFuY-n-Z7_atjXkBIfK9","warning":"_2mUnCBQWZLmSzm7i0c2baj","error":"_1mmgLmCcL3JjwqUdvAxgFV"};


//////////////////
// WEBPACK FOOTER
// ./src/views/fragments/messages/style.css
// module id = 696
// module chunks = 0